module.exports = __webpack_public_path__ + "img/p.b5affc48.svg";